/**
 * 存储类型
 */

/**
 * window.localStorage
 */
const WINDOW = '1';

/**
 * sinline app
 */
const SUNLINE = '2';

const WEIXIN = '3';

const storageEnum = [];

storageEnum.WINDOW = WINDOW;

storageEnum.SUNLINE = SUNLINE;

storageEnum.WEIXIN = WEIXIN;

storageEnum.window = (code) => {
  return code == WINDOW;
};

storageEnum.sunline = (code) => {
  return code == SUNLINE;
};

storageEnum.weixin = (code) => {
  return code == WEIXIN;
};
export default storageEnum;

// account-open模块的user存取块
export const USER_STORAGE_KEY = 'userInfo';

export const ENCRYPT_KEY = 'encrypt_key';

export const DEVICE_ID_KEY = 'device_id_key';



// WEBPACK FOOTER //
// ./src/enums/storageEnum.js